<script lang="ts">
    import { t } from 'svelte-i18n';

    let currentQuote = 0;

    const quotes = [
        {
            quote: '"... große Weine mit eigenem Charakter, der launischen Natur abgerungen."',
            author: 'Der Stern'
        },
        {
            quote: '"I could drink quite a lot of this stuff."',
            author: 'The Best Sommelier of the World. Andreas Larsson'
        },
        {
            quote: '"I was blown off my feet by its energy and concentration."',
            author: 'Jancis Robinson'
        },
        {
            quote: '"I could happily drink the whole bottle for lunch!"',
            author: 'Jancis Robinson'
        },
        {
            quote: '"Wow – einfach nur wow! Die Weine begeistern, faszinieren, machen fast sprachlos. Großes Kino!"',
            author: 'Gault Millau, Weinguide Deutschland 2018'
        },
        {
            quote: '"Power, Raffinesse, Eleganz, Tiefe ohne Ende – unglaublich."',
            author: 'Sommelier Justin Leone'
        },
        {
            quote: '"Voller Spannung, tiefgründig, immens mineralisch, salzig, von dichter Textur, Trinkfreude pur!"',
            author: 'Falstaff'
        },
        {
            quote: '"Elegant leichtfüßige Meisterwerke."',
            author: 'Frankfurter Allgemeine Zeitung'
        }
    ];
</script>

<div class="order-3 lg:order-2 flex flex-col uppercase justify-between">
    <div class="block lg:hidden h-[1px] bg-neutral-700 mb-6" />
    <div class="flex flex-col gap-4 max-w-sm w-full">
        <div class="flex justify-between">
            <h2 class="w-3/4 font-medium tracking-[0.143rem] font-grey">{quotes[currentQuote].author}</h2>
            <button
                on:click={() => {
                    if (currentQuote !== quotes.length - 1) currentQuote += 1;
                    else currentQuote = 0;
                }}
                class="lg:hidden size-10 border border-primary flex justify-center items-center group"
            >
                <svg
                    width="22"
                    height="14"
                    class="fill-none stroke-1 stroke-primary group-hover:sm:fill-primary transition-colors"
                    viewBox="0 0 26 14"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0.947725 7.0127L7.35898 0.601436L24.6312 7.0127L7.35898 13.424L0.947725 7.0127Z" />
                </svg>
            </button>
        </div>
        <h1 class="text-4xl font-cinzel text-primary">
            {quotes[currentQuote].quote}
        </h1>
    </div>
    <div class="hidden lg:flex gap-4">
        <button
            on:click={() => {
                if (currentQuote !== 0) currentQuote -= 1;
                else currentQuote = quotes.length - 1;
            }}
            class="size-10 border border-primary flex justify-center items-center group"
        >
            <svg
                width="22"
                height="14"
                class="fill-none stroke-1 stroke-primary group-hover:sm:fill-primary transition-colors"
                viewBox="0 0 26 14"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M25.0523 7.0127L18.641 0.601436L1.36885 7.0127L18.641 13.424L25.0523 7.0127Z" />
            </svg>
        </button>
        <button
            on:click={() => {
                if (currentQuote !== quotes.length - 1) currentQuote += 1;
                else currentQuote = 0;
            }}
            class="size-10 border border-primary flex justify-center items-center group"
        >
            <svg
                width="22"
                height="14"
                class="fill-none stroke-1 stroke-primary group-hover:sm:fill-primary transition-colors"
                viewBox="0 0 26 14"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M0.947725 7.0127L7.35898 0.601436L24.6312 7.0127L7.35898 13.424L0.947725 7.0127Z" />
            </svg>
        </button>
    </div>
</div>
